import { render, staticRenderFns } from "./dialog_printcode.vue?vue&type=template&id=12d4fd1d&scoped=true&"
import script from "./dialog_printcode.vue?vue&type=script&lang=js&"
export * from "./dialog_printcode.vue?vue&type=script&lang=js&"
import style0 from "./dialog_printcode.vue?vue&type=style&index=0&id=12d4fd1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d4fd1d",
  null
  
)

export default component.exports